import API from "../../api";
import { API_USER_MASTER_IMPORT } from "../../constants/api";

const importUser = async (data) => {
  const headers = {
    'Content-Type': 'multipart/form-data',
  };
  try {
    const response = await API.post(API_USER_MASTER_IMPORT, data, {headers});
    return response.data;
  } catch (e) {
    throw e.response
  }
};


const UserImportServices = {
  importUser,
};

export {
  UserImportServices as default,
  importUser
}
